import cn from "clsx";
import { ProgressBar } from "@crehana/compass.ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProgressBarDetailed = function ProgressBarDetailed(_ref) {
  var progress = _ref.progress,
    label = _ref.label,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-relative tw-w-full",
    children: [/*#__PURE__*/_jsx("div", {
      className: cn('tw-relative tw-flex tw-items-center tw-w-full tw-h-1.6 tw-px-0.4 tw-rounded-0.8 tw-overflow-hidden', label && 'tw-mb-0.8', {
        'bg-gray-lighter-dark-mode': isDark,
        'bg-gray-light': !isDark
      }),
      children: /*#__PURE__*/_jsx(ProgressBar, {
        progress: progress,
        className: "tw-rounded-1"
      })
    }), label && /*#__PURE__*/_jsx("div", {
      className: "tw-font-caption tw-text-right tw-w-full text-base-lighter",
      children: label
    })]
  });
};
export default ProgressBarDetailed;